
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ForecastSort extends Vue {
  @Prop()
  public sortKey!: any

  @Prop()
  public label!: any

  @Prop()
  public value!: any

  public changeSort() {
    let val: any = {
      key: this.sortKey,
      sort: this.value.sort === 'asc' ? 'desc' : 'asc',
    }

    if (this.value.key !== this.sortKey) {
      val = {
        key: this.sortKey,
        sort: 'desc',
      }
    }

    this.$emit('input', val)
  }
}
